// The reference starts unpublished, so creating it puts nothing in front of readers.
export const API_REFERENCE_CREATED =
	"API reference created. Publish it when it's ready."

export const NEW_API_REFERENCE = {
	name: "API reference",
	slug: "api-reference",
}
